import { useToast } from '@/hooks/useToast'

interface CardData {
  title: string;
  description: string;
  metadata?: {
    playerName?: string;
    universe?: string;
    language?: string;
    rarity?: string;
    element?: string;
    [key: string]: any;
  };
}

export function useShare() {
  const { toast } = useToast()

  const handleShare = async (cardData: CardData) => {
    if (!cardData) return

    const cardText = `
      🎴 ${cardData.title}

      ${cardData.description}

      Created by: ${cardData.metadata?.playerName || 'Anonymous'}
      Universe: ${cardData.metadata?.universe || 'Unknown'}
      Language: ${cardData.metadata?.language || 'en'}
      ${cardData.metadata?.rarity ? `Rarity: ${cardData.metadata.rarity}` : ''}
      ${cardData.metadata?.element ? `Element: ${cardData.metadata.element}` : ''}
      ${Object.entries(cardData.metadata || {})
        .filter(([key]) => !['playerName', 'universe', 'language', 'rarity', 'element'].includes(key))
        .map(([key, value]) => `${key}: ${value}`)
        .join('\n')}
    `.trim()

    try {
      await navigator.clipboard.writeText(cardText)
      toast({
        title: "Copied to clipboard!",
        description: "Card details have been copied to your clipboard.",
        duration: 2000,
      })
    } catch (error) {
      toast({
        title: "Failed to copy",
        description: "Please try again",
        variant: "destructive",
      })
    }
  }

  return { handleShare }
} 